import { ChatRow } from 'components/chats/ChatRow'
import { ListEmptyComponent } from 'components/ui/ListEmptyComponent'
import { ChatBubbleSparklesSvg } from 'components/ui/svg/ChatBubbleSparklesSvg'
import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'
import { messagesSelectors } from 'store/messages'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'
import { isEmpty, size } from 'lodash'
import { sortChatsByLastMessage } from 'utils/chats'
import { UIButton } from 'components/ui/Button'
import { ChatsDiv } from 'components/ui/MessageDiv'
import clsx from 'clsx'
import { useModalActions } from 'providers/ModalProvider'
import { useGetSetting } from 'api/settings'
import { openNewChat } from 'api/chats'
import { useGetAreas } from 'api/areas'
import { useUserChatListSocket } from 'hooks/useUserChatListSocket'

export const ChatsList = () => {
  const { setting } = useGetSetting()
  const { t } = useTranslation()
  const { showOpenChat } = useModalActions()
  const chatsMap = useSelector(messagesSelectors.chats)
  const currentUserId = useSelector(settingsSelectors.userId)
  const areaId = useSelector(settingsSelectors.areaId)
  const isMultiArea = useSelector(settingsSelectors.isMultiAreaFlow)
  const { data: areas } = useGetAreas()
  const [loading, setLoading] = useState(false)
  const sortedChats = useMemo(() => sortChatsByLastMessage(chatsMap), [chatsMap])

  useUserChatListSocket(currentUserId ? String(currentUserId) : undefined)

  const openChatWithCurrentAreaId = async (areaId: string) => {
    try {
      setLoading(true)
      await openNewChat({ areaId })
    } finally {
      setLoading(false)
    }
  }

  const onClickOpenChat = async () => {
    if (isMultiArea) {
      try {
        setLoading(true)
        await openNewChat({})
      } finally {
        setLoading(false)
      }
      return
    }
    if (areaId) {
      return await openChatWithCurrentAreaId(areaId)
    }
    if (size(areas) === 1) {
      const firstArea = areas[0]
      return await openChatWithCurrentAreaId(firstArea._id)
    }
    showOpenChat()
  }

  return (
    <>
      <ChatsDiv
        className={clsx(
          'tw-flex-grow tw-w-full tw-flex-col tw-self-start tw-overflow-y-auto tw-bg-transparent tw-p-2 tw-pt-2 tw-py-2',
        )}
        widgetColor={setting?.primaryColor}
      >
        {isEmpty(sortedChats) && (
          <ListEmptyComponent
            image={<ChatBubbleSparklesSvg />}
            title={t('emptyChats')}
            description={t('emptyChatsHint')}
          />
        )}
        {sortedChats.map((chat) => (
          <ChatRow chat={chat} key={chat._id} />
        ))}
      </ChatsDiv>
      <div className={clsx('tw-flex-row tw-items-center tw-w-full tw-px-3 tw-mt-1 tw-mb-4')}>
        <UIButton
          color={setting?.primaryColor}
          loading={loading}
          className={'tw-p-2 tw-rounded-2xl tw-w-full tw-text-white'}
          onClick={onClickOpenChat}
        >
          {t('openNewChat')}
        </UIButton>
      </div>
    </>
  )
}
